<template>
    <div style="background-color: rgba(49,63,65,0.8);" class="modal show fade" :id="code" :data-backdrop="stat" tabindex="-1" role="dialog" aria-labelledby="ModalConexionTitle" aria-hidden="true">
        <div :class="`${size} modal-dialog modal-dialog-centered animated bounce`" role="document">
            <div class="modal-content">
                <div class="modal-header" v-if="head">
                    <slot name="header"></slot>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body"><slot></slot></div>
                <div class="modal-footer" v-if="foot"><slot name="footer"></slot></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            code: {
                type: String,
                required: true
            },
            head: {
                type: Boolean,
                default: true
            },
            foot: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: ""
            },
            stat: {
                type: String,
                default: ""
            },
        },
    }
</script>

<style scoped>

</style>